var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"placement-icon",style:(`width: ${ _vm.size }px; height: ${ _vm.size }px`),attrs:{"src":_vm.iconPath,"alt":`${ _vm.placement } placement icon`}})
}
var staticRenderFns = []

export { render, staticRenderFns }